export const utilities = {
  methods: {
    isMobile: function() {
      let result = false;
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        result = true;
      }
      return result;
    },
  },
};
